module.exports = __webpack_public_path__ + "img/kz_pic6.dd60df89.png";